import React from "react";
import {Message} from "semantic-ui-react"

export const UNABLE_TO_FETCH = "Unable to fetch the details. Please try again.";

export const getErrorNode = () =>  (<Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{UNABLE_TO_FETCH}</p>
            </Message>);

export default getErrorNode;


// WEBPACK FOOTER //
// ./src/utils/errorUtil.js